<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 md12 pa-2 v-show="!profile.confirmed">
        <v-card>
          <v-toolbar dense flat >
            <v-toolbar-title>Подтверждение электронной почты
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            Для продолжения работы с системой Вам необходимо ввести код подтверждения, код был послан на адрес электронной почты {{profile.email}}.
            <v-text-field v-model = "confirmationCode" label="Код подтверждения" type="text" clearable></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="confirmEmail">Подтвердить</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 md6 pa-2>
        <v-card :height="'100%'">
          <v-toolbar dense flat >
            <v-toolbar-title>Обо мне
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <div v-show="isNeedPersonAgreement">
              <div>
              <a href="/">Политика обработки персональных данных</a>
              </div>
              <div>
              <a href="/">Согласие на обработку персональных данных</a>
              </div>
              <v-checkbox v-show="isNeedPersonAgreement" label="Даю согласие" persistent-hint
                hint="Политику обработки персональных данных изучил, Даю свое соглашение на обработку моих персональных данных" v-model="needPersonAgreementCheck"></v-checkbox>
            </div>
            <v-form ref="profile" v-model="profileValid">
             <v-layout row wrap>
              <v-text-field name="lastName" :value = "profile.lastName" label="Фамилия" type="text" ></v-text-field>
              <v-text-field name="firstName" :value = "profile.firstName" label="Имя" type="text" ></v-text-field>
             </v-layout>
             <v-layout row wrap>
              <v-text-field name="middleName" :value = "profile.middleName" label="Отчество" type="text"  ></v-text-field>
              <v-text-field name="phone" :value = "profile.phone" :rules="phoneRules" label="Тел. личный" type="text"  clearable></v-text-field>
             </v-layout>
              <v-checkbox v-show="editProfile" hide-details label="Изменить параметры входа" v-model="needCredentials"></v-checkbox>
             <v-layout row wrap>
              <v-text-field :readonly="!needCredentials" name="email" :value = "profile.email" label="Эл. почта" type="text" :rules="emailRules"  :clearable="needCredentials"></v-text-field>
             </v-layout>
             </v-form>
             <v-layout row wrap>
              <v-text-field v-show="needCredentials && editProfile" ref="newPassword" type="password" label="Пароль" :rules="passwordRules" v-model = "password"  :clearable="needCredentials"></v-text-field>
              <v-text-field v-show="needCredentials && editProfile" ref="retype" v-model = "retype"
              :error-messages="errorRetype()"
              type="password" label="Подтверждение" hint="Подтвердите пароль" :clearable="needCredentials"></v-text-field>
             </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn v-show="editProfile" :disabled="isNeedPersonAgreement && !needPersonAgreementCheck" @click="saveProfile" >Сохранить</v-btn>
            <v-btn v-show="!editProfile" @click="editProfile=true">Изменить</v-btn>
          </v-card-actions>
        </v-card>
        </v-flex>
      <v-flex xs12 md6 pa-2>
        <v-card flat ref="scroll_target" class="scroll-y" :height="calcHeight()">
          <v-toolbar dense flat >
            <v-toolbar-title>Мои компании
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container pt-2 px-2
            fluid
            grid-list-lg
            style="min-height: 0; margin-top: "
          >
            <v-layout row wrap >

              <template v-for="item in accountClients">
                <v-flex >
                <v-card>
                  <v-card-title>
                    <span class="subheading">{{item.clientNameShort}}</span>
                    <v-spacer></v-spacer>
                    <v-icon v-show="isCurrentClient(item)">done</v-icon>
                  </v-card-title>
                  <v-card-text>
                    <div>Эл. почта компании: <b>{{item.clientEmail}}</b></div>
                    <div>Тел. рабочий: <b>{{item.clientPhone}}</b></div>
                    <div>Полномочия: <b>{{item.roleNotes}}</b></div>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn v-show="!isCurrentClient(item)" @click="setCurrentClient(item)">Сделать текущей</v-btn>
                  </v-card-actions>
                </v-card>
                  </v-flex>
              </template>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import vActionLogsPanel from './ActionLogsPanel'

  export default {
    name: 'profile',
    components: {vActionLogsPanel},
    data: () => ({
      editProfile: false,
      needCredentials: false,
      password: '',
      retype: '',
      confirmationCode: '',
      clientValid: true,
      profileValid: true,
      enableClientCheck: false,
      needPersonAgreementCheck: false,
      clientInnRules: [
        v => !!v || 'Введите ИНН организации, которую Вы представляете',
        v => formats.isInn(v) || 'Неверный формат ИНН'
      ],
      emailRules: [
        v => !!v || 'Введите адрес электронной почты, для идентификации в системе',
        v => formats.isEmail(v) || 'Неверный формат эл. почты'
      ],
      clientEmailRules: [
        v => !!v || 'Введите адрес Вашей корпоративной электронной почты, для оповещений системы',
        v => formats.isEmail(v) || 'Неверный формат эл. почты'
      ],
      passwordRules: [
        v => !!v || 'Введите пароль',
        v => formats.isPassword(v) || 'Пароль должен содержать латинские символы и цифры'
      ],
      phoneRules: [
        v => !v || formats.isPhone(formats.formatPhone(v)) || 'Формат номера +7(921)1234567'
      ]
    }),
    mounted () {
      this.$store.dispatch('fetchAccountClients')
    },
    computed: {
      ...mapGetters({
        profile: 'getProfile',
        getAccountClients: 'getAccountClients'
      }),
      isRequested () {
        return /CONFIRMED/i.test(this.accountClient.state) || /NEW/i.test(this.accountClient.state)
      },
      isNeedPersonAgreement () {
        return (false && !this.profile.rulesAgreed)
      },
      statusText () {
        var ac = this.accountClient
        if (!(ac && ac.state && ac.state.length > 0)) {
          return ''
        }
        if (/CONFIRMED/i.test(ac.state)) {
          return 'Данные подтверждены '
        }
        if (/NEW/i.test(ac.state)) {
          return 'Запрос ожидает подтверждения '
        }
        if (/REJECTED/i.test(ac.state)) {
          return 'Запрос отклонен'
        }
      },
      accountClients () {
        return this.getAccountClients.slice(0).sort((a, b) => formats.compareString(a.clientNameShort, b.clientNameShort))
      },
      enableClient () {
        return this.profile.confirmed &&
        this.profile.lastName && this.profile.lastName.length > 0 &&
        this.profile.firstName && this.profile.firstName.length > 0 &&
        (!this.isRequested || this.enableClientCheck)
      }

    },
    methods: {
      calcHeight () {
        var height = this.$vuetify.breakpoint.height - 56 - 48
        return height + 'px'
      },
      confirmEmail () {
        this.$store.dispatch('confirmEmail', this.confirmationCode)
      },
      errorRetype () {
        if (this.needCredentials &&
          (this.password !== this.retype)) {
          return ['Пароли не совпадают']
        }
        return []
      },
      saveProfile () {
        if (this.$refs.profile.validate()) {
          var els = this.$refs.profile.$el.elements
          var r = {}
          for (var i = 0; i < els.length; i++) {
            if ((els[i]) && (els[i].name)) {
              r[els[i].name] = els[i].value
            }
          }
          r['phone'] = formats.formatPhone(r['phone'])
          if (this.needCredentials &&
            this.$refs.newPassword.validate(true) &&
            this.$refs.retype.validate(true)) {
            r['newEmail'] = els['email'].value
            r['newPassword'] = this.password
          }
          this.$store.dispatch('saveAccountProfile', r)
          this.editProfile = false
        }
      },
      setCurrentClient (item) {
        this.$store.dispatch('setCurrentClient', item.clientId)
      },
      isCurrentClient (item) {
        return this.profile && (this.profile.clientInn === item.clientInn)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Profile.vue?181eff92